module.exports = __webpack_public_path__ + "img/lowertable.4e8aaacf.svg";